module.exports = __webpack_public_path__ + "static/media/rental-income.2c7dd470.svg";